export default "__VITE_ASSET__6cfab48d__"